import { render, staticRenderFns } from "./IndustryList.vue?vue&type=template&id=a161ee14&"
import script from "./IndustryList.vue?vue&type=script&lang=js&"
export * from "./IndustryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports